import React, { useEffect } from 'react';
import { browserHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import MinimalNav from '../MinimalNav';

import { authUserOperations } from '@evdy/web-redux/dist/lib/authUser';
import { getAPIUrl } from '@evdy/web-redux/dist/constants';

import { screenNameRoutes } from '../../constants';

import styles from './ResumePurchase.module.scss';

const { resumePurchaseFlow, resetResumePage } = authUserOperations;

const { 'resume-purchase': resumePurchaseClass } = styles;

const API_URL_LOCAL_3000 = getAPIUrl('', 3000);

const ResumePurchase = ({ params }) => {
  const { userData, orderSubmitted, resumePageSuccess, isFetching } = useSelector(
    ({ authUser }) => ({
      userData: authUser?.data,
      orderSubmitted: authUser?.orderSubmitted,
      resumePageSuccess: authUser?.resumePageSuccess,
      isFetching: authUser?.isFetching
    })
  );
  const dispatch = useDispatch();

  const { screen } = userData?.preneed?.lastScreen ?? {};
  const windowLocation = global?.window && window?.location;
  const userId = params?.userId;

  // login on mount
  useEffect(() => {
    // show screen for 1.5 seconds before redirect
    if (userId) {
      setTimeout(() => {
        dispatch(resumePurchaseFlow({ userId }));
      }, 1500);
    }
  }, [userId]);

  // reset after success
  useEffect(() => {
    if (resumePageSuccess) {
      dispatch(resetResumePage());
    }
  }, [resumePageSuccess]);

  //redirct to purchase flow
  useEffect(() => {
    //on successful login
    if (!isFetching && resumePageSuccess) {
      // if user has completed the purchase flow in a different session, redirect to /your-funeral-package
      if (windowLocation) {
        window.location.href = `${API_URL_LOCAL_3000}/plan/home`;
      }
    }
  }, [isFetching, orderSubmitted, resumePageSuccess, screen, windowLocation]);

  return (
    <div className={resumePurchaseClass}>
      <MinimalNav pageCopy="resuming your purchase" />
      <h4>Welcome Back!</h4>
      <p>Resuming your purchase where you left off, please be patient...</p>
    </div>
  );
};

export default ResumePurchase;
